module.exports = __webpack_public_path__ + "static/media/00_gauchahoje.04d045c1.jpg";